import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';
import {IconComponent} from '../shared/icon/icon.component';

@Component({
  selector: 'app-footer',
    imports: [
        RouterLink,
        IconComponent
    ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.sass'
})
export class FooterComponent {

}
